import { SET_COMPANY_SCOPE, INIT_COMPANY_SCOPE } from "./actionTypes"

// localStorage is the source of truth read by the axios interceptor (api_helper.js),
// so the reducer keeps it in sync. The selector UI reads this slice for reactivity.

const readScope = () => {
  try {
    const raw = localStorage.getItem("companyScope")
    if (raw) return JSON.parse(raw)
  } catch (e) {
    /* ignore */
  }
  // Fall back to the logged-in user's default company.
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
    const def = authUser?.company_context?.default_company_id
    if (def) {
      const scope = { scopeType: "company", scopeId: def }
      localStorage.setItem("companyScope", JSON.stringify(scope))
      return scope
    }
  } catch (e) {
    /* ignore */
  }
  return { scopeType: "company", scopeId: null }
}

const persist = scope => {
  try {
    localStorage.setItem("companyScope", JSON.stringify(scope))
  } catch (e) {
    /* ignore */
  }
}

const INIT_STATE = readScope()

const Company = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_COMPANY_SCOPE: {
      const scope = {
        scopeType: action.payload.scopeType === "group" ? "group" : "company",
        scopeId: action.payload.scopeId,
      }
      persist(scope)
      return { ...state, ...scope }
    }
    case INIT_COMPANY_SCOPE:
      return readScope()
    default:
      return state
  }
}

export default Company
